<template>
  <v-footer
    color="text-center white--text"
    padless
    dark
  >
    <v-row
      justify="center"
      no-gutters
    >
      <v-btn
        v-for="link in links"
        :key="link[1]"
        :href="link[1]"
        color="white"
        text
        rounded
      >
        {{ link[0] }}
      </v-btn>
    </v-row>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      ['Início', 'meu-painel'],
      ['Calendário', 'calendario'],
      ['Agendamento', 'agendamento'],
      ['Tags', 'tags'],
      ['Cliente', 'cliente'],
      ['Usuários', 'user'],
    ],
  }),
};
</script>
